import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { CameraPermissionInstructionsDialog } from './CameraPermissionInstructionsDialog'

export const CameraBlockedBanner = ({ message, onRetry, isRetrying, isDenied }) => {
  const { t } = useTranslation()
  const [dialogOpen, setDialogOpen] = useState(false)

  const displayMessage = isDenied
    ? t('generate_shipment.camera_blocked_banner.permission_denied_message')
    : (message || t('generate_shipment.camera_blocked_banner.default_message'))

  const handleClick = () => {
    if (isDenied) {
      setDialogOpen(true)
    } else {
      onRetry()
    }
  }

  const buttonLabel = isRetrying
    ? t('generate_shipment.camera_blocked_banner.detecting')
    : isDenied
      ? t('generate_shipment.camera_blocked_banner.permission_denied_cta')
      : t('generate_shipment.camera_blocked_banner.retry_button')

  return (
    <>
      <div role="alert" aria-live="assertive" className="bg-red-50 border-l-4 border-red-400 p-4 mb-4 flex items-start justify-between">
        <div className="flex-1 pr-4">
          <p className="text-sm font-medium text-red-800">
            {t('generate_shipment.camera_blocked_banner.title')}
          </p>
          <p className="text-sm text-red-700 mt-1">{displayMessage}</p>
        </div>
        <button
          type="button"
          onClick={handleClick}
          disabled={isRetrying}
          className="ml-3 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {buttonLabel}
        </button>
      </div>
      <CameraPermissionInstructionsDialog open={dialogOpen} setOpen={setDialogOpen} />
    </>
  )
}
